import { Flex } from 'foundations-components/components/Flex';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SHIMMER_SIZE = 1200;
const SHIMMER_POSITION = 700;
const SHIMMER_DELAY = `0s`;
const SHIMMER_DURATION = `1s`;
const SHIMMER_ITERATION = 'infinite';
const SHIMMER_FILL_MODE = 'forwards';
const SHIMMER_TIMING_FUNC = 'linear';
const SkeletonBase = styled.div.withConfig({
  displayName: "SkeletonLoadWrapper__SkeletonBase",
  componentId: "nsexwj-0"
})(({
  theme,
  height,
  width
}) => ({
  height: `${height}px`,
  overflow: 'hidden',
  position: 'relative',
  width: typeof width === 'number' ? `${width}px` : width,
  background: theme.color['fill-tertiary-hover'],
  backgroundImage: `linear-gradient(
      to right,
      ${theme.color['fill-tertiary-hover']},
      ${theme.color['fill-tertiary-default']} 20%,
      ${theme.color['fill-tertiary-hover']} 40%
    )`,
  backgroundSize: `${SHIMMER_SIZE}px`,
  animation: `shimmer ${SHIMMER_DURATION} ${SHIMMER_TIMING_FUNC} ${SHIMMER_DELAY} ${SHIMMER_ITERATION} ${SHIMMER_FILL_MODE}`,
  '@keyframes shimmer': {
    '0%': {
      backgroundPosition: `-${SHIMMER_POSITION}px 0`
    },
    '100%': {
      backgroundPosition: `${SHIMMER_POSITION}px 0`
    }
  }
}));
const SkeletonLoadWrapper = ({
  isLoading,
  children,
  widths = [],
  heights = []
}) => {
  if (isLoading) {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      gap: "100",
      children: widths.map((width, index) => /*#__PURE__*/_jsx(SkeletonBase, {
        "aria-busy": true,
        "data-loading": true,
        height: heights[index],
        width: width
      }, index))
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default SkeletonLoadWrapper;